  //newURL=null, //pageTemplate=null //oldPageURL=null //newPageURL=null //collectionsObject=null
  let newPageURL=null;
  function PageRedirection(newURL=null, pageTemplate=null, oldPageURL=null, newPageURL=null, collectionsObject=null){
    
    let pageOrigin  = newURL.origin;
    let pagePathName  = newURL.pathname.split('/');
    let pageProtocol  = newURL.protocol;
    
    //console.log(pageOrigin, pagePathName, pageProtocol);
    
    if( pageTemplate == 'page' && oldPageURL != pagePathName[2]){
       
      //Page: https://www.druids.com/pages/bundle-builder ==>//Redirect to: https://www.druids.com/pages/golf-ambassador-pack
      //console.log(newURL, pageTemplate, oldPageURL, newPageURL, pagePathName[1], pagePathName[2]);
      //console.log(pageOrigin + '/' + pagePathName[1] + '/' + newPageURL);
      window.location.replace(pageOrigin + '/' + pagePathName[1] + '/' + newPageURL);
      
    }
    //console.log('Normal Js PageRedection Script done!', newURL, pageTemplate, oldPageURL, newPageURL, collectionsObject);
  }
  // PageRedirection End

  function removejscssfile(filename, filetype){
    var targetelement=(filetype=="js")? "script" : (filetype=="css")? "link" : "none" //determine element type to create nodelist from
    var targetattr=(filetype=="js")? "src" : (filetype=="css")? "href" : "none" //determine corresponding attribute to test for
    var allsuspects=document.getElementsByTagName(targetelement)
    for (var i=allsuspects.length; i>=0; i--){ //search backwards within nodelist for matching elements to remove
      if (allsuspects[i] && allsuspects[i].getAttribute(targetattr)!=null && allsuspects[i].getAttribute(targetattr).indexOf(filename)!=-1)
        allsuspects[i].parentNode.removeChild(allsuspects[i]) //remove element by calling parentNode.removeChild()
    }
  
  }
  // removejscssfile End

  /* ======================================== Remove js,css files End ======================================== */

  function axiosApiPageRedirection(f=null, s=null, collectionsObject=null){
    
    let pages = null;
    let spage = null;
    let completeURL = null;
    
    if(f == 'page'){pages='pages'}
    else if(f == 'product'){ pages = 'products';}  
    else if(f == 'collection'){ pages = 'collections';}
    else if(f == 'collections') { pages = 'list-collections';}
    else{return false;}
    console.log(f,s, collectionsObject);
    
    if(s != ''){ spage = s;}else{return false;}
    if( pages != '' && spage != '') {completeURL = `${pages}/${spage}`;}
    else if(pages != '') {completeURL = `${pages}`; }
    else{return false;}
    console.log(pages, spage, completeURL);
    
    let config = {
      method: 'get',
      maxBodyLength: Infinity,
      url: `https://mlc.druidsgolf.de/api/getSingleRedirectUrl/${completeURL}`,      
    };
    
    axios.request(config)
    .then((response) => {
      console.log(JSON.stringify(response.data));
      //console.log(response.data.target);
      window.location.replace(response.data.target);
    })
    .catch((error) => {
      console.log(error);
    });
    
  }
  // axiosApiPageRedirection End


  function axiosApiSPageRedirection(f=null){
  
    let pages=null;
  
    if(f == 'list-collections') { pages = 'collections';}
    else{return false;}
    console.log(f);
    
    let config = {
      method: 'get',
      maxBodyLength: Infinity,
      url: `https://mlc.druidsgolf.de/api/getSingleRedirectUrl/${pages}`,      
    };
    
    axios.request(config)
    .then((response) => {
      //console.log(JSON.stringify(response.data));
      window.location.replace(response.data.target);      
    })
    .catch((error) => {
      console.log(error);
    });
    
  }
  // axiosApiSPageRedirection End
  